import styled from 'styled-components';
export const StatsWrapper = styled.div`
  color: white;
  height: calc(${({ altura }) => altura}px - 40px);

  display: flex;
  padding: 10px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    overflow-y: scroll;
  }
`;
export const NumbersWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 15px;
`;
export const GraphContainer = styled.div`
  height: 100%;
  width: 100%;
`;
export const HalfWrapper = styled.div`
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const InputWrapper = styled.div`
  width: 350px;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const TotalWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
export const Text = styled.p`
  font-size: 14px;
  margin: 0;
`;
export const TextWrapper = styled.div`
  /* display: flex; */
  /* width: 100%; */
  /* gap: 10px; */
`;

export const ElementWrapper = styled.div`
  display: flex;
  margin-top: 4px;
  /* flex-direction: column; */
  align-items: center;
  /* justify-content: center; */
  width: 100%;
  gap: 5px;
`;
export const Value = styled.div`
  display: flex;
  font-size: 14px;
  padding: 2px 10px;
  align-items: center;
  justify-content: center;
  border: 1px solid #666666;
  background-color: #33333360;
  border-radius: 5px;
`;
